import { connect } from 'react-redux';

import { getPermissions } from '../Login/selectors';
import { getAbbreviationsQueueStats, updateAbbreviation } from './actionSagas';
import AudioGenerationQueue from './AudioGenerationQueue';
import { getAbbreviationsQueueData } from './selectors';

const mapStateToProps = (state) => ({
  audioGenerationQueueData: getAbbreviationsQueueData(state),
  permissions: getPermissions(state),
});

const mapDispatchToProps = (dispatch) => ({
  getQueueData: () => dispatch(getAbbreviationsQueueStats()),
  updateAudioGeneration: (action) => dispatch(updateAbbreviation(action)), // Keep same prop name
});

const AbbreviationsQueueContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(AudioGenerationQueue);

export default AbbreviationsQueueContainer;
